'use client'
import { FormField } from '@/components/ui/form/form'
import { FieldPath, FieldValues, UseControllerProps } from 'react-hook-form'

// Extend props with transactionName
interface HiddenInputProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> extends UseControllerProps<TFieldValues, TName> {
  transactionName: string
}
export const HiddenInput = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  transactionName,
  ...props
}: HiddenInputProps<TFieldValues, TName>) => {
  return (
    <FormField
      {...props}
      render={({ field }) => (
        <input
          data-transaction-name={transactionName}
          type="hidden"
          {...field}
        />
      )}
    />
  )
}
